<template>
    <div class="mdl-layout__drawer">
        <img id="brand-logo" :src="logo" alt="Document Storage Logo">
        <span class="mdl-layout-title">Document Storage</span>
        <nav class="mdl-navigation">
            <router-link
              to="/"
              class="mdl-navigation__link"
            >
              <i class="material-icons">folder_open</i>
              <span>My Documents</span>
            </router-link>
            <router-link
              class="mdl-navigation__link"
              :to="`/company/${this.$store.getters.user.group_id}`"
            >
              <i class="material-icons">work</i>
              <span>Company Documents</span>
            </router-link>
            <a class="mdl-navigation__link" @click.prevent="logout">
              <i class="material-icons">exit_to_app</i>
              Logout
            </a>
        </nav>
    </div>
</template>

<script>
export default {
  data: () => ({
    logo: require('../assets/logo.svg')
  }),
  computed: {
    routes () {
      return this.$router.options.routes.filter(route => route.meta && route.meta.sidebar)
    }
  }
}
</script>
